// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__U8IPA","content":"style_content__m8Kq2","description":"style_description__w4mn9"};